const modalTriggerButtons = document.querySelectorAll("[data-modal-target]");
const modals = document.querySelectorAll(".modal");
const modalCloseButtons = document.querySelectorAll(".modal-close");

modalTriggerButtons.forEach(elem => {
  elem.addEventListener("click", event => toggleModal(event.currentTarget.getAttribute("data-modal-target")));
});
modalCloseButtons.forEach(elem => {
  elem.addEventListener("click", event => toggleModal(event.currentTarget.closest(".modal").id));
});
modals.forEach(elem => {
  elem.addEventListener("click", event => {
    if(event.currentTarget === event.target) toggleModal(event.currentTarget.id);
  });
});

// Close Modal with "Esc"...
document.addEventListener("keydown", event => {
  if(event.keyCode === 27 && document.querySelector(".modal.modal-show")) {
    toggleModal(document.querySelector(".modal.modal-show").id);
  }
});

function toggleModal(modalId) {
  const modal = document.getElementById(modalId);

  if(modal.classList.contains("modal-show")) { // alternatively: if(modal.classList.contains("modal-show"))
    modal.classList.add("modal-hide");
    setTimeout(() => {
               document.body.style.overflow = "initial";
               modal.classList.remove("modal-show", "modal-hide");
    modal.style.display = "none";      
  }, 200);
}
else {
  document.body.style.overflow = "hidden";
  modal.style.display = "flex";
  modal.classList.add("modal-show");
}
}

$("#script_photo").on("change", function(e){
  console.log(e.target.files[0].name);
  $(".selected-prespriction").text(e.target.files[0].name);
  $(".selected-prespriction").addClass("active");
  $("#pet-prescription").val(e.target.files[0].name);
   $("#upload_img_filename").text(e.target.files[0].name);
  removeDisabled();
});

$(".prescription_file").click(function(){
  $(".selected-prespriction").text($(".prescription_file").text());
  $("#pet-prescription").val($(".prescription_file").text());
  $(".selected-prespriction").addClass("active");
  removeDisabled();
});


$(document).ready(function(e){
  
   $.ajax({
    type: "GET",
     url:'/cart.js',
     success: function(data){
     	console.log(data);
     }
   });
  var cust_id = window.customerId;
  $.ajax({
    type: "GET",
    url: "https://scriptly.brdsites.com/api/v1/customer/"+cust_id+"/pets",
    dataType: "json",
    success: function(data) {
      console.log(data);
      $data = JSON.stringify(data);
      for(var a = 0; a < data.length; a++)
      {
        $(".pet-list-mini-cart").prepend("<li class='pet-name' data-value='"+ data[a]["id"] +"'>"+ data[a]["name"] +"</li>");
      }
      setTimeout(pdp_addCart, 2000)  
    },
    error: function(data) {
      console.log(data);
    }
  });
  
  function get_petnames(){
    $.ajax({
      type: "GET",
      url: "https://scriptly.brdsites.com/api/v1/customer/"+cust_id+"/pets",
      dataType: "json",
      success: function(data) {
        console.log(data);
        $data = JSON.stringify(data);
        for(var a = 0; a < data.length; a++)
        {
          $(".pet-name-mini-cart").prepend("<li class='pet-name' data-value='"+ data[a]["id"] +"'>"+ data[a]["name"] +"</li>");
        }
        setTimeout(pdp_addCart, 2000)  
      },
      error: function(data) {
        console.log(data);
      }
    });
  }

 
});
function pdp_addCart(){
  $(".pet-api").css("display","block");
  var acc = document.getElementsByClassName("pet-name");
  var i;
  var li_count = $(".pet-list-mini-cart li").length;
  for (i = 0; i < li_count; i++) {
    acc[i].addEventListener("click", function() {
      $(".selected-pet").text($(this).text());
      $(".pet-name-list-option").val($(this).text());
      $("#pet-id").val($(this).data("value"));
      $(".selected-pet").addClass("active");
      removeDisabled();
    });
  }
}

function removeDisabled(){
  if($(".selected-pet").hasClass("active") && $(".selected-prespriction").hasClass("active"))
  {
    $(".product-form__submit").removeAttr("disabled");
  }
}

